/* eslint-disable */
import React from 'react';
import logo from '../../images/SideBarImg/Delievery_white.png';
import hireLogo from '../../images/SideBarImg/H2R_white.png';
import orderLogo from '../../images/SideBarImg/O2C_white.png';
import procureLogo from '../../images/SideBarImg/P2P_white.png';
import recordLogo from '../../images/SideBarImg/R2R_white.png';
import importLogo from '../../images/gdcImages/delivery/import_logistic.svg';

export const DeliveryLogoIcon = ({ size = 24 }) => (
  <img src={logo} alt="Delivery Logo" style={{ width: size, height: size }} />
);


export const OrderLogoIcon = ({ size = 24 }) => (
  <img src={orderLogo} alt="Order to Cash" style={{ width: size, height: size }} />
);


export const HireLogoIcon = ({ size = 24 }) => (
  <img src={hireLogo} alt="Hire to Retire" style={{ width: size, height: size }} />
);


export const ProcureLogoIcon = ({ size = 24 }) => (
  <img src={procureLogo} alt="Procure to Pay" style={{ width: size, height: size }} />
);


export const RecordLogoIcon = ({ size = 24 }) => (
  <img src={recordLogo} alt="Record to Report" style={{ width: size, height: size }} />
);

export const ImportLogisticsIcon = ({ size = 24 }) => (
  <img src={importLogo} alt="Import Logistics" style={{ width: size, height: size }} />
);